import { mc } from '@lss/common/game/characters/MC';
import Game from '../../src/shell/Game';
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from '../characters/Ann';
import { chris } from '../characters/Chris';
import { vanessa } from '../characters/Vanessa';
import { doTransition } from '../helpers/helpers';
import { images } from "./images";
import { V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson, V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson2 } from './V5';


export const V5AnnLibrary = async (): Promise<any> => {

    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber && Question.globalAnswers.v3KeepAnsweringChris) {
        ImageClass.setImage(images.v5.AnnLibraryV5_0, { duration: 0.6 });

    } else {
        ImageClass.setImage(images.v5.AnnLibraryV5_1, { duration: 0.6 });

    }

    mc.think(`There is Ann.`);
    if (Question.globalAnswers.v3KeepAnsweringChris) {
        mc.think(`She didn't mention that Chris is with her...`);
        ann.talk(`And that's how you do a bypass surgery...`);
        ann.talk(`Am I right?`);
        chris.talk(`That's right, you were just wrong on one part.`);
        ann.talk(`On which part?`);
        ImageClass.setImage(images.v5.AnnLibraryV5_2);
        chris.talk(`You should insert the scalpel from here.`);
        ann.talk(`Hehehe, stop.`);
        ImageClass.setImage(images.v5.AnnLibraryV5_3);
        mc.talk(`...`);
        ann.talk(`Hehehe.`);
        ImageClass.setImage(images.v5.AnnLibraryV5_4);
    } else {
        ImageClass.setImage(images.v5.AnnLibraryV5_5);
        ann.talk(`${mc.name}! Hey!`);
        ImageClass.setImage(images.v5.AnnLibraryV5_14);
        ann.talk(`Muah!`);
        ImageClass.setImage(images.v5.AnnLibraryV5_10);
        ann.talk(`What a pleasant surprise!`);
        mc.talk(`Vanessa asked me to try and convince you to come with me to her house.`);
        return jump(V5AnnLibrary_NoChris, "V5AnnLibrary_NoChris");
    }

    return jump(V5AnnLibrary_Question, "V5AnnLibrary_Question");
};

export const V5AnnLibrary_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnLibraryV5_4);
    await mc.setQuestion(new Question({ text: `Vanessa asked me to try and convince you to come with me to her house.`, options: { think: false }, key: `v5AnnLibraryAskedAboutChris` })
        .option({ title: `What Chris is doing here?`, key: true })
        .option({ title: `Let her answer`, key: false }));


    if (Question.globalAnswers.v5AnnLibraryAskedAboutChris) {

        return jump(V5AnnLibrary_Chris, "V5AnnLibrary_Chris");
    } else {
        return jump(V5AnnLibrary_NoChris, "V5AnnLibrary_NoChris");
    }
};

export const V5AnnLibrary_Chris = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnLibraryV5_6);
    mc.talk(`What Chris is doing here?`);
    ann.talk(`He is helping me.`);
    ann.talk(`I don't know if I told you, but I study medicine.`);
    ann.talk(`And there is an operation I couldn't understand, and it happens that Chris knows all about that.`);
    chris.talk(`I used to be pre-med before I became a bartender.`);
    mc.talk(`That's a drastic change.`);
    chris.talk(`My mother is a doctor, she wanted me to follow her path. I tried, but it's not for me.`);


    return jump(V5AnnLibrary2, "V5AnnLibrary2");
};

export const V5AnnLibrary_NoChris = async (): Promise<any> => {
    if (Question.globalAnswers.v3KeepAnsweringChris) {

        ImageClass.setImage(images.v5.AnnLibraryV5_6);
    } else {

        ImageClass.setImage(images.v5.AnnLibraryV5_10);
    }

    ann.talk(`Oh... I really need to finish this subject.`);
    ann.talk(`I mean, I am happy to see you! But I need to catch up on stuff.`);

    return jump(V5AnnLibrary2, "V5AnnLibrary2");
};

export const V5AnnLibrary2 = async (): Promise<any> => {
    if (Question.globalAnswers.v3KeepAnsweringChris) {

        ImageClass.setImage(images.v5.AnnLibraryV5_6);
        ImageClass.setImage(images.v5.AnnLibraryV5_8);
        chris.talk(`You deserve a break, we are almost done.`);
        ImageClass.setImage(images.v5.AnnLibraryV5_15);
        ann.talk(`Are we?`);
        ImageClass.setImage(images.v5.AnnLibraryV5_7);
        chris.talk(`Yes, you see, you need to learn this procedure, and that's it. It's not a complicated one.`);
        ann.talk(`Great!`);
        ImageClass.setImage(images.v5.AnnLibraryV5_15);
        chris.talk(`Have fun, I need to get going myself.`);
        ann.talk(`Ok, thank you for helping me!`);
        chris.talk(`Anytime.`);
    }


    return jump(V5AnnLibrary3, "V5AnnLibrary3");
};

export const V5AnnLibrary3 = async (): Promise<any> => {

    if (Question.globalAnswers.v3KeepAnsweringChris) {
        ImageClass.setImage(images.v5.AnnLibraryV5_10);
        ann.talk(`I had no idea he had medical knowledge.`);
        mc.talk(`Me neither. Surprising.`);
        ImageClass.setImage(images.v5.AnnLibraryV5_11);
        ann.talk(`I know!`);
    } else {
        ann.talk(`Did I tell you that I'm studying to become a doctor?`);
        ImageClass.setImage(images.v5.AnnLibraryV5_10);
        mc.talk(`I don't think so.`);
        ann.talk(`Oh.`);
        ann.talk(`Well I am.`);
    }

    if (Game.seenScenarios.includes(`V5AnnLibrary_Chris`)) {

        ann.talk(`So like I was saying, I'm studying to become a doctor...`);
    }
    ann.talk(`It's so hard. Sometimes I don't know if I have it in me.`);
    mc.talk(`I'm sure you will be a great doctor.`);
    mc.talk(`I'm always happy to help you with the male anatomy if you ever need me to.`);
    ImageClass.setImage(images.v5.AnnLibraryV5_13);
    ann.talk(`Hehe.`);
    ImageClass.setImage(images.v5.AnnLibraryV5_10);
    ann.talk(`What were you doing at Vanessa's house anyway?`);
    mc.talk(`Apparently, her parents have never seen Joey, and for some reason, Vanessa hides him from them.`);
    mc.talk(`So she asked me to come over and pretend to be him...`);
    ImageClass.setImage(images.v5.AnnLibraryV5_11);
    ann.talk(`Oh, wow.\nHow was it?`);
    mc.talk(`Weird...`);
    ann.talk(`I can understand, I always have the feeling they don't like me.`);
    mc.think(`To say the least.`);
    ann.talk(`Maybe I'm just imagining it.`);
    ann.talk(`How did Vanessa convince you to come here?`);
    mc.talk(`I didn't need convincing, she just asked and I agreed.`);
    ann.talk(`She wanted me to go over to her house yesterday but I was busy here...`);
    mc.talk(`That's a good reason why you should go now.`);
    ImageClass.setImage(images.v5.AnnLibraryV5_12);
    ann.talk(`Mmm...`);
    ImageClass.setImage(images.v5.AnnLibraryV5_11);
    ann.talk(`You did walk all this way for me...`);
    ann.talk(`It wouldn't be fair to send you back empty-handed.`);
    mc.talk(`Is that a yes?`);
    ann.talk(`Yes, let's go.`);
    return jump(V5AtVanessasHouse, "V5AtVanessasHouse");
};
export const V5AtVanessasHouse = async (): Promise<any> => {
    doTransition(images.v5.VanessaAfterBreakfast_4);
    vanessa.talk(`Finally!`);
    vanessa.talk(`I can't believe you almost bailed on me.`);
    ann.talk(`I had to study...`);
    vanessa.talk(`Study later, it's not gonna be long.`);
    ann.talk(`Did we disturb you putting on clothes?`);
    vanessa.talk(`No.`);
    ann.talk(`So why are you in your bra...?`);
    vanessa.talk(`I was waiting for you before I was gonna change.`);
    ann.talk(`Why?`);
    vanessa.talk(`It's a surprise.\nWait here.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_5);
    vanessa.talk(`${mc.name}, make sure she doesn't run away.`);
    mc.talk(`Alright.`);
    ImageClass.setImage(images.v5.VanessaAfterBreakfast_6);

    ann.talk(`What is she planning to do?`);
    mc.talk(`I honestly have no idea.`);
    ann.talk(`Who does? Hehe.`);
    ann.talk(`But I think I have a small clue...`);
    ann.talk(`Let's sit down.`);
    ImageClass.setImage(images.v5.AnnVanessaRoom_0);


    ann.talk(`Ok, so do you remember the thing we were talking about a couple of days ago?`);
    mc.talk(`I do...`);
    ann.talk(`So I think she took it way too seriously...`);
    mc.talk(`We are about to find out.`);
    return jump(V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson, "V5VanessaBreakfastVanessaRoomAnnJoinedSexLesson");
};
